<style>
	.bg757 {
		background-color: #f2f7fa;width:100%;height:100vh;overflow-y:auto;
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
} 
.my_top{width:84vw;margin-left:7vw;margin-top:1vw;background:#fff;height:10vw;position:relative;border-radius:.5vw;overflow:hidden;}
.my_top img.logo{display:block;position:absolute;width:4vw;height:4vw;left:1vw;top:.5vw;}
.school_name{position:absolute;left:6vw;top:.5vw;width:40vw;height:2vw;}
.school_name span.school{display:block;font-size:1.4vw;font-weight:bold; float:left;}
.school_name img.phone{display:block; height:1vw; float:left;margin-top:.5vw;margin-left:1vw;}
.school_name span.number{display:block;font-size:1.1vw; float:left;line-height:2vw;margin-left:.5vw;color:#999;}


.expired{position:absolute;left:6vw;top:2.5vw;width:40vw;height:2vw;}
.expired span.dueto{display:block;font-size:1.1vw;  float:left;margin-left:.5vw;line-height:2vw;}
.expired img.msg{display:block; height:1vw; float:left;margin-top:.5vw;margin-left:0;}
.expired span.attention{display:block;font-size:1.1vw; float:left;line-height:2vw;margin-left:.5vw; height:2vw;border:#f66060 solid 1px;color:#f00;font-weight:bold;
padding:0 .5vw;border-radius:.5vw;box-sizing:border-box;}
.daoqi{float:left;height:2vw;border:#f2dbb0 solid 1px;
padding:0 .5vw;border-radius:.5vw;box-sizing:border-box;}
.zixun{position:absolute;right:0;top:0;background:#e3e9ff;padding:0 1vw;height:2vw;line-height:2vw;font-size:1.1vw;border-bottom-left-radius:.5vw;
color:#3465FF;}
.pwd{position:absolute;right:0;bottom:5vw;height:2vw;}
.pwd span{display:block;float:left;line-height:2vw;font-size:1.1vw;color:#999;cursor:pointer;}
.pwd span.p1{margin-right:1vw;}
.pwd span.p1:hover{color:#cc0000;text-decoration:underline;}
.pwd span.p2{margin-right:1vw;}
.pwd span.p2:hover{color:#cc0000;text-decoration:underline;}
.pwd img.edit{ float:left;width:1.2vw;margin-right:.5vw;margin-top:.3vw;}




.my_top_sw{width:100%;height:4vw;background: linear-gradient(222deg, #F2DBB0 0%, #E6BE6C 100%);position:absolute;bottom:0;}
.mail{width:5vw;height:4vw;background:url(../../assets/images/mail.png) #ffe6b4 no-repeat center center;float:left;background-size:1.6vw;}
.my_top_sw span.dx{display:block;float:left;line-height:4vw;font-size:1.2vw;color:#795a19;padding-left:1vw;}
.my_top_sw b{color:#333;padding:0 .5vw}
.fen{widh:1px;height:1vw;margin-top:1.5vw;border-right:#795a19 solid 1px;float:left;margin-left:.5vw;}
.my_nav{margin:0;padding:0;overflow:hidden;width:84vw;margin-left:7vw;margin-top:1vw;background:#fff;border-radius:.5vw;height:7.4vw;}
.tab{width:100%;height:3.8vw;border-bottom:#f2f6fc solid 1px;}
.tab ul.ab{width:100%;}
.tab ul.ab li{float:left;padding:0 2vw;font-size:1.2vw;font-weight:bold;line-height:3.8vw;cursor:pointer;}
.tab ul.ab li.on{border-bottom:#3268ff  solid 0.15vw;}
.nav{width:95%;margin:0 auto;}
.nav span{display:block;float:left;line-height:3.6vw;line-height:3.6vw;font-size:1.2vw;text-align:center;}
.nav span.aa{width:20%;text-align:left;}
.nav span.bb{width:25%;}
.nav span.cc{width:20%;}
.nav span.dd{width:20%;}
.nav span.ee{width:15%;}

.nav span.ff{width:15%;float:right; }
.nav span.gg{width:20%; }
.nav span.hh{width:20%;text-align:left;}
.nav span.ii{width:25%;text-align:center;}
 
.msg_list{width:84vw;margin-left:7vw;margin-top:1vw;background:#fff;min-height:3vw;border-radius:.5vw;}
.msg_list ul{width:100%;margin:0 auto; }
.msg_list ul li{height:3.6vw;width:95%;padding:0 2.5%;}
.msg_list ul li span{display:block;line-height:3.6vw;float:left;text-align:center;font-size:1.2vw;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}
.msg_list ul li span.aa{width:20%;text-align:left;}
.msg_list ul li span.bb{width:25%;}
.msg_list ul li span.cc{width:20%;}
.msg_list ul li span.dd{width:20%;}
.msg_list ul li span.ee{width:15%;}

.msg_list ul li span.ff{width:15%;float:right; }
.msg_list ul li span.gg{width:20%;}
.msg_list ul li span.hh{width:20%;text-align:left;float:left;}
.msg_list ul li span.ii{width:25%;text-align:center; }


.msg_list ul li:nth-child(even){background:#f5f6f7;}
.msg_list ul li:nth-child(odd){background:#fff;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:2.5vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}


.progress22{width:35vw;height:28vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd2{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd2 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
.progress_hd2 img.cha{display:block;width:2vw;height:2vw;float:right;margin-top:1vw;margin-top:1vw;cursor:pointer;}


 
.progress22 span.ma1{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.1vw;color:#999;margin-top:1vw;}
.progress22 span.ma2{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.4vw;color:#333;margin-top:1vw;font-weight:bold;}

.ma_box33{width:70%;margin:0 auto;height:3.5vw;margin-top:1.5vw;border-radius:.5vw;text-indent:1vw;}
.ma_box33 input{width:65%;float:left;border:#ddd solid 1px;height:3.5vw;font-size:1.1vw;color:#333;border-radius:.5vw;text-indent:1vw;}
.ma_box33 button{width:30%;float:right;height:3.5vw;background:#f5f5f5;border:0;outline:none;font-size:1.1vw;border:#ddd solid 1px;border-radius:.5vw;}
.ma_box33 button:active{background: #d1d1d5;}
.ma_box33 input::placeholder{text-indent:1vw;color:#999;font-size:1.1vw;}
.ma_box21{width:70%;margin:0 auto;height:3.5vw;margin-top:1vw;border-radius:.5vw;text-indent:1vw;}
.ma_box21 input{width:100%;float:left;border:#ddd solid 1px;height:3.5vw;font-size:1.1vw;color:#333;border-radius:.5vw;text-indent:1vw;}
.ma_box21 input::placeholder{text-indent:1vw;color:#999;font-size:1.1vw;}


.progress22 button.submits33{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:2vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
 
.progress2 button.submits5{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:1vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.biao_list{width:70%;max-height:10vw;border:#ddd solid 1px;margin-top:1vw;scroll:no;overflow-y:auto;border-top-left-radius:.5vw;border-top-right-radius:.5vw;}
.biao_list ul{margin:0 auto;width:95%;}
.biao_list ul li{width:100%;height:2vw;margin-top:.5vw;}
.biao_list ul li img{display:block;width:2vw;float:left;}
.biao_list ul li span{display:block;width:20vw;float:left;line-height:2vw;font-size:1.1vw;color:#0F7A3E;text-overflow:ellipsis;white-space:nowrap;}
.biao_tj{width:70%;margin:0 auto;border:#ddd solid 1px;height:3vw;border-top:0;border-bottom-left-radius:.5vw;border-bottom-right-radius:.5vw;}
.biao_tj span{display:block;line-height:3vw;float:left;text-align:center;font-size:1vw;}
.biao_tj span.bio1{width:49%;border-right:#ddd solid 1px;box-sizing:border-box; }
.biao_tj span.bio2{width:50%;}
.biao_tj b{color:#FA9C3B;font-weight:normal;}

.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw;}
</style>
 
<template>
	<div class="bg757">
	       <transition name="draw">
			   <div class="mengban" v-show="safe_show"></div>
	       </transition>
		   <transition name="draw">
	       <div class="progress22" v-show="safe_show">
				  <div class="progress_hd2"><span class="ap">发送安全码</span><img @click="close()" class="cha" src="../../assets/images/cha.png"></div>
				  <span class="ma1">安全码将发送到当前账号绑定的手机</span>  
				  <span class="ma2">{{safe_phone}}</span>  
			      <div class="ma_box33">
				      <input type="text" v-model="code" placeholder="请输入安全码">
					  <button id="send" @click="send()" >获取安全码</button>
				  </div>
				  <div class="ma_box21">
				      <input type="password" v-model='password' placeholder="请输入新密码">
				  </div>
				  <button class="submits33" @click="sure3()">确定</button>
		   </div>
	      </transition>
		
	     <u_center  ></u_center>
		 <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
		 </div>
	      <div class="my_top">
		      <img :src="img" class="logo">
			  <div class="school_name">
				  <span class="school">{{school_name}}</span>
				  <img src="../../assets/images/phone.png" class="phone">
				  <span class="number">{{phone}}</span>
				  
			  </div>
			  <div class="expired">
			     <div class="daoqi">
			      <img src="../../assets/images/crown.png" class="msg">
				  <span class="dueto">会员期限：{{start_time|formatDate}}-{{end_time|formatDate}}</span>
				 </div>
				  <span class="attention" v-if="expire_show">会员即将到期，请联系028-85071717</span>
			  </div>
			  <div class="zixun">咨询热线：028-85071717</div>
			  <div class="pwd">
			     <img src="../../assets/images/edit.png" class="phone edit">
			     <span class="p1" @click="pwd()">修改密码</span>
				 <span class="p2" @click="logout()">退出</span>
			  </div>
			  <div class="my_top_sw">
			     <div class="mail"></div>
				 <span class="dx">短信总数：<b>{{balance*1+used*1}}</b>条</span>
				 <div class="fen"></div>
				 <span class="dx">已使用过：<b>{{used}}</b>条</span>
				 <div class="fen"></div>
				 <span class="dx">剩余：<b>{{balance}}</b>条</span>
			  </div>
		  </div>
		  <div class="my_nav">
		      <div class="tab">
			     <ul class="ab">
				   <li :class="tab_class1" @click="tab(1)">短信发送记录</li>
				   <li :class="tab_class2" @click="tab(2)">充值记录</li>
				 </ul>
			  </div>
			  <div style="clear:both;"></div>
			  <div class="nav" v-if="type==2">
			      <span  class="aa">订单号</span>
			      <span  class="bb">充值时间</span>
				  <span  class="cc">充值金额</span>
				  <span  class="dd">短信条数</span>
				  <span  class="ee">类型</span>
			  </div>
			  <div class="nav" v-if="type==1">
			      <span  class="hh">数据源</span>
				  <span  class="ii">模板名</span>
                  <span  class="gg">发送条数</span>
				  <span  class="ff">发送时间</span>
			  </div>
		  </div>
		  <div class="msg_list">
		   <div style="clear:both;"></div>
		     <ul v-if="type==2">
			   <li v-for="item in list1"><span class="aa">{{item.sn}}</span><span class="bb">{{item.time|formatDate2}}</span><span class="cc">¥{{item.amount}}</span><span class="dd">{{item.pcs}}</span><span class="ee">{{item.category}}</span></li>
			 </ul>
			 <ul v-if="type==1">
			   <li v-for="item in list2"><span class="hh">{{item.name}}</span><span class="ii">{{item.temp}}</span><span class="gg">{{item.success}}</span><span class="ff">{{item.time|formatDate2}}</span></li>
			 </ul>
		  </div>
		   <div class="pages" v-if="type==2 && total_page1>1">
				<div class="pre" @click="pre_page1()"   v-if="page1>1">
				   <img src="../../assets/images/pre2.png">
				</div>
				<div class="pre"   v-else>
				   <img src="../../assets/images/pre1.png">
				</div>
				
				<div class="next" @click="next_page1()" v-if="page1<total_page1">
				   <img src="../../assets/images/next1.png">
				</div>
				<div class="next"  v-else>
				   <img src="../../assets/images/next2.png">
				</div>
		  </div>
		  <div class="pages" v-if="type==1 && total_page2>1">
				<div class="pre" @click="pre_page2()"   v-if="page2>1">
				   <img src="../../assets/images/pre2.png">
				</div>
				<div class="pre"   v-else>
				   <img src="../../assets/images/pre1.png">
				</div>
				
				<div class="next" @click="next_page2()" v-if="page2<total_page2">
				   <img src="../../assets/images/next1.png">
				</div>
				<div class="next"  v-else>
				   <img src="../../assets/images/next2.png">
				</div>
		  </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				 tab_class1:'on',
				 tab_class2:'',
				 safe_show:false,
				 token:"",
				 school_name:"",
				 img:"",
				 phone:"",
				 safe_phone:"",
				 balance:0,
				 used:0,
				 start_time:'',
				 end_time:'',
				 expire_show:false,
				 list1:[],
				 list2:[],
				 page1:1,
				 page2:1,
				 total_page1:1,
				 total_page2:1,
				 type:1,
				 password:"",
				 code:""
			}
		},
		mounted() {
		     let self=this;
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_user_info();
				  self.get_recharge_list();
				  self.get_sending_list();
			  }  
		    
		 
			
		},
		filters: {
				formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "/" + month + "/" + date.getDate() ;
					return time;
				},formatDate2: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "/" + month + "/" + date.getDate() +" "+hours+" "+minutes   ;
					return time;
				}
			},
		methods: {
			send(){
								  let self=this;
										axios.post(this.$api+'/home/send_safe_code', {
										   token: self.token
										  }).then(function (response) {  
						
										  let data=response.data;
									 
										  if(data.state==1){
										  
											 var countdown=60; 
											 function settime(){    

													   if (countdown > 0) {
																	 self.disabled=true
																	
																	 document.getElementById("send").innerHTML = "重新发送"+countdown;
																	  countdown--; 

														 } else if(countdown == 0)   { 

																	 countdown=null;
																	// document.getElementById("send").setAttribute("disabled",false);
																	 document.getElementById("send").disabled="";
																	
																	 document.getElementById("send").innerHTML = "获取验证码";
																	 return ;

														 } else{

																				 return;

															  }
											  }
												setInterval(function() { settime() },1000) 	 
										  }else{
											 self.$toast.center(data.msg);
										  }
									 
									  }).catch(function (error) {
											   
									  });
			},sure3(){
		      let self=this;
		      axios.post(this.$api+'/home/change_pwd', {
					   token:self.token,
					   code:self.code,
					   pwd:self.password
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){      
						 
					 self.$toast.center('密码修改成功');
						 
                          self.safe_show=false;
                          	
					  
					  				  
				  }else{
				     self.$toast.center(data.msg);
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		   pre_page1(){
		     if(this.page1>1){
			    this.page1=this.page1-1;
				this.get_recharge_list();
			 }
		   },next_page1(){
		      if(this.page1<this.total_page1){
			    this.page1=this.page1+1;
				this.get_recharge_list();
			  }
		   },
		    pre_page2(){
		     if(this.page2>1){
			    this.page2=this.page2-1;
				this.get_sending_list();
			 }
		   },next_page2(){
		      if(this.page2<this.total_page2){
			    this.page2=this.page2+1;
				this.get_sending_list();
			  }
		   },
		   logout(){	        
		             localStorage.setItem(
							  "token",""
                     );	
					  this.$router.push("/");  
		  },
		   pwd(){
		     this.safe_show=true;
		   },
		   close(){
		     this.safe_show=false;
		   },
		   get_user_info(){	        
		      let self=this;
		      axios.post(this.$api+'/home/get_user_info', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.school_name=data.data.school_name; 
                     self.img=data.data.img;
                     self.phone=data.data.phone; 
                     self.safe_phone=data.data.safe_phone;
                     self.balance=data.data.balance;	
                     self.used=data.data.used;
                     self.start_time=data.data.start_time;
                     self.end_time=data.data.end_time;
                     if(data.data.expire==1){
					   self.expire_show=true;
					 }					 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },get_recharge_list(){
		     let self=this;
		      axios.post(this.$api+'/home/get_recharge_list', {
					   token:self.token,
					   page:self.page1
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list1=data.data.list;			
                     self.total_page1=data.data.total_page;					 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },get_sending_list(){
		     let self=this;
		      axios.post(this.$api+'/home/get_sending_list', {
					   token:self.token,
					   page:self.page2
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list2=data.data.list;			
                     self.total_page2=data.data.total_page;					 
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		    home(){
			  this.$router.push("/");  
			},
		   tab(val){
		      if(val==1){
			    this.tab_class1='on';
				this.tab_class2='';
				this.type=1;
			  }else{
			    this.tab_class2='on';
				this.tab_class1='';
				this.type=2;
			 }
		   }
		     
		},watch:{
			  
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/my/index.vue